import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetMappingTemplateResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const GetMappingTemplate = new ReduxAsyncAction<'GET_MAPPING_TEMPLATE', string, GetMappingTemplateResponseActionPayload>(
  'GET_MAPPING_TEMPLATE'
);

GetMappingTemplate.registerRequest(async (id: string) => {
  try {
    const response = await dash_api.get<GetMappingTemplateResponseActionPayload>(`/v1/skadnetworkv2/templates/${id}`);

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get mapping template. Please try again.', 'error');

    throw error;
  }
});

export const GET_MAPPING_TEMPLATE = GetMappingTemplate.actionNamespaceConstants;

export const getMappingTemplate = GetMappingTemplate.request;

export type GetMappingTemplateRequestAction = Action<typeof GET_MAPPING_TEMPLATE.request>;

export type GetMappingTemplateResponseAction = Action<typeof GET_MAPPING_TEMPLATE.response> & {
  data: GetMappingTemplateResponseActionPayload;
};
